import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { AtendimentoPage } from './pages/AtendimentoPage';
import { ProtectedRoute } from './components/ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/atendimento" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/atendimento',
    element: (
      <ProtectedRoute>
        <AtendimentoPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
